import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Navbar";
export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#06152d] text-white py-12 border-t border-[#d4af37]/20 text-xs">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/images/logo.png" alt="Dahmani Food" className="w-8 h-8 rounded-lg" />
          <span className="font-display text-sm tracking-wider">DAHMANI FOOD SRLS</span>
        </div>

        <div className="text-white/60 text-center md:text-left leading-relaxed">
          © {new Date().getFullYear()} Dahmani Food srls · P.IVA 11660540961<br />
          Sede legale: Via Lattanzio 60, 20137 Milano · Magazzino: Via Alessandro Volta 15, 20089 Rozzano (MI) · +39 375 608 8043
        </div>

        <div className="flex gap-6 text-white/70 uppercase tracking-widest text-[10px]">
          <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#d4af37] transition-colors">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-link-cookie" className="hover:text-[#d4af37] transition-colors">Cookie Policy</Link>
        </div>
      </div>
    </footer>
  );
}
